// Created on 2021-04-12
// Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential
// Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-12
const storage = {
  /**
   * SETTINGS
   * @vte
   */
  getSettings: function (name, defaultValue) {
    return JSON.parse(window.localStorage.getItem('settings.' + name)) || defaultValue
  },
  setSettings: function (name, value, defaultValue) {
    window.localStorage.setItem('settings.' + name, JSON.stringify(value || defaultValue))
    return JSON.parse(window.localStorage.getItem('settings.' + name)) || defaultValue
  },
  /**
   * CUSTOMERS
   * @vte
   */
  saveAllCustomers: (customers) => {
    return new Promise((resolve, reject) => {
      try {
        window.localStorage.setItem('customers', JSON.stringify(customers))
        window.localStorage.setItem('customersT', {value: 'a'})
        resolve(customers)
      } catch (e) {
        reject(e)
      }
    })
  },
  getAllCustomers: () => {
    return new Promise((resolve, reject) => {
      try {
        const customers = JSON.parse(window.localStorage.getItem('customers') || "[]")
        resolve(customers)
      } catch (e) {
        reject(e)
      }
    })
  },
  getCustomer: (id) => {
    return new Promise((resolve, reject) => {
      try {
        const customers = JSON.parse(window.localStorage.getItem('customers') || "[]")
        let result = {};
        (customers || []).forEach(item => {
          const tmpCustomer = item || {}
          if (id === (tmpCustomer.pzsCode + '_' + tmpCustomer.id + '_' + tmpCustomer.idOz)) {
            result = tmpCustomer
          }
        })
        resolve(result)
      } catch (e) {
        reject(e)
      }
    })
  },
  updateCustomer: (newCustomer) => {
    newCustomer.updatedTime = Date.now()
    return new Promise((resolve, reject) => {
      try {
        const customers = JSON.parse(window.localStorage.getItem('customers') || "[]");
        for (let i in customers) {
          if ((newCustomer.pzsCode + '_' + newCustomer.id + '_' + newCustomer.idOz) === (customers[i].pzsCode + '_' + customers[i].id + '_' + customers[i].idOz)) {
            customers[i] = newCustomer
            break;
          }
        }
        storage.saveAllCustomers(customers)
          .then(resolve)
          .catch(reject)
      } catch (e) {
        reject(e)
      }
    })
  },
  deleteCustomer: (newCustomer) => {
    return new Promise((resolve, reject) => {
      try {
        const customers = JSON.parse(window.localStorage.getItem('customers') || "[]");
        for (let i in customers) {
          if ((newCustomer.pzsCode + '_' + newCustomer.id + '_' + newCustomer.idOz) === (customers[i].pzsCode + '_' + customers[i].id + '_' + customers[i].idOz)) {
            customers[i].deletedTime = Date.now()
            break;
          }
        }
        storage.saveAllCustomers(customers)
          .then(resolve)
          .catch(reject)
      } catch (e) {
        reject(e)
      }
    })
  },
  undeleteCustomer: (newCustomer) => {
    return new Promise((resolve, reject) => {
      try {
        const customers = JSON.parse(window.localStorage.getItem('customers') || "[]");
        for (let i in customers) {
          if ((newCustomer.pzsCode + '_' + newCustomer.id + '_' + newCustomer.idOz) === (customers[i].pzsCode + '_' + customers[i].id + '_' + customers[i].idOz)) {
            customers[i].deletedTime = undefined
            break;
          }
        }
        storage.saveAllCustomers(customers)
          .then(resolve)
          .catch(reject)
      } catch (e) {
        reject(e)
      }
    })
  },
  createCustomer: (newCustomer) => {
    newCustomer.addedTime = Date.now()
    return new Promise((resolve, reject) => {
      try {
        const customers = JSON.parse(window.localStorage.getItem('customers') || "[]");
        customers.push(newCustomer)
        storage.saveAllCustomers(customers)
          .then(resolve)
          .catch(reject)
      } catch (e) {
        reject(e)
      }
    })
  }
}

export default storage